import React,{useState,useEffect} from 'react';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import FormLabel from '@mui/material/FormLabel';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import useMediaQuery from '@mui/material/useMediaQuery';
import InputString from './InputString';
import {Theme} from './Theme';
import {EventTagNameLengthMax,EventTagNameLengthMin,EventTagUrlLengthMax,EventTagUrlLengthMin} from './Inc';
import useStyles from './Styles';

interface EventNewProps {
    yes(event:any):void,
    no():void,
    isOpen:boolean,
}

const EventNew = (props:EventNewProps)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
	const defStates = {
		event: {
			name: "",
			start_year: "",
			start_month: "",
			start_day: "",
			end_year: "",
			end_month: "",
			end_day: "",
			url: "",
		},
		error: {
			name: true,
			start_year: true,
			start_month: true,
			start_day: true,
			end_year: false,
			end_month: false,
			end_day: false,
			url: false,
		},
		hasError: true,
		isLoading: false,
		toast: "",
	};
	const [states,setStates] = useState(defStates);

	const onChangeString = (key: keyof typeof states.event)=>(value:string,hasError:boolean)=>{
		const newEvent = {...states.event};
		(newEvent as any)[key] = value;

		const newError = {...states.error};
		(newError as any)[key] = hasError;

		//newErrorにtrueがあればhasErrorをtrueにする
		let numError = 0;
		for( const k in newError ){
			if( (newError as any)[k] ){
				numError++;
			}
		}

		setStates({...states,event:newEvent,error:newError,hasError: numError>0});
	}

	const send = ()=>{
		props.yes( states.event );
	}

	useEffect( ()=>{
		if( props.isOpen ){
			setStates(defStates);
		}
	},[props.isOpen])

    if( !props.isOpen ){
        return (null);
    }

    return (
		<Dialog
			fullScreen={fullScreen}
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.no();
				}
			}}
		>
			<DialogTitle color='primary'>イベントの仮登録</DialogTitle>
			<DialogContent>
				<div style={{marginBottom:"1em",fontSize:"90%"}}>
					イベント名と初日の年月日が必須項目です。<br/>
					それ以外はわかる範囲で入力して下さい。<br/>
				</div>
				<Divider/>
				<div style={{width:"100%",minWidth:"300px"}}>
					<div style={{marginTop:"1rem"}}>
						<InputString label="イベント名" required={true} value={states.event.name} onChange={onChangeString("name")} helper={EventTagNameLengthMax+'文字以内'} opt={{minLength:EventTagNameLengthMin,maxLength:EventTagNameLengthMax}}/>
					</div>
					<div style={{marginTop:"1rem"}}>
						<FormLabel component="label" className={classes.formLabel}>初日（始まる日）</FormLabel>
						<Grid container spacing={2}>
							<Grid item xs={4}>
								<InputString
									label="年"
									required={true}
									value={states.event.start_year}
									regex={"^(19[8-9][0-9]|20[0-9]{2})$"}
									regexError="1980から2099までの数字で入力してください"
									onChange={onChangeString("start_year")}
								/>
							</Grid>
							<Grid item xs={4}>
								<InputString
									label="月"
									required={true}
									value={states.event.start_month}
									regex={"^([1-9]|0[1-9]|1[0-2])$"}
									regexError="1～12の数字で入力してください"
									onChange={onChangeString("start_month")}
								/>
							</Grid>
							<Grid item xs={4}>
								<InputString
									label="日"
									required={true}
									value={states.event.start_day}
									regex={"^([1-9]|0[1-9]|1[0-9]|2[0-9]|3[0-1])$"}
									regexError="1～31の数字で入力してください"
									onChange={onChangeString("start_day")}
								/>
							</Grid>
						</Grid>
					</div>
					<div style={{marginTop:"1rem"}}>
						<FormLabel component="label" className={classes.formLabel}>最終日（終わる日）</FormLabel>
						<Grid container spacing={2}>
							<Grid item xs={4}>
								<InputString
									label="年"
									required={false}
									value={states.event.end_year}
									regex={"^(19[8-9][0-9]|20[0-9]{2}$"}
									regexError="1980から2099までの数字で入力してください"
									onChange={onChangeString("end_year")}
								/>
							</Grid>
							<Grid item xs={4}>
								<InputString
									label="月"
									required={false}
									value={states.event.end_month}
									regex={"^([1-9]|0[1-9]|1[0-2])$"}
									regexError="1～12の数字で入力してください"
									onChange={onChangeString("end_month")}
								/>
							</Grid>
							<Grid item xs={4}>
								<InputString
									label="日"
									required={false}
									value={states.event.end_day}
									regex={"^([1-9]|0[1-9]|1[0-9]|2[0-9]|3[0-1])$"}
									regexError="1～31の数字で入力してください"
									onChange={onChangeString("end_day")}
								/>
							</Grid>
						</Grid>
					</div>
					<div style={{marginTop:"2rem"}}>
						<InputString label="公式サイトURL" required={false} value={states.event.url} onChange={onChangeString("url")} helper={EventTagUrlLengthMax+'文字以内'} opt={{minLength:EventTagUrlLengthMin,maxLength:EventTagUrlLengthMax}}/>
					</div>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='決定' disabled1={states.hasError} onClick1={send} button2='やめる' onClick2={props.no} bottom={0}/>
			</DialogActions>
        </Dialog>
    );
}

export default EventNew;
